import { RemoteGetAllActivitiesByStudent } from 'data/usecases';
import { GetAllActivitiesByStudent } from 'domain/usecases';
import { makeApiUrlActivitiesByStudent } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllActivitiesByStudent = (): GetAllActivitiesByStudent =>
  new RemoteGetAllActivitiesByStudent(
    makeApiUrlActivitiesByStudent(),
    makeAxiosHttpClient(),
  );
